module.exports = __webpack_public_path__ + "img/bs-4.a4f8c773.jpg";